import { LIST_MEDIA, SET_MEDIA_LOADING } from "../contants";

const initialState = {
  mediaList: [],
  listMediaLoading: true,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case LIST_MEDIA: {
      return {
        ...state,
        mediaList: action.payload,
      };
    }
    case SET_MEDIA_LOADING: {
      return {
        ...state,
        listMediaLoading: action.payload,
      };
    }
    default:
      return state;
  }
};
export default reducer;
